export default __webpack_public_path__ + "static/media/fund.11362f8b.svg";